import { Construction } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full border-0 shadow-2xl">
        <CardContent className="pt-12 pb-10 px-8 text-center">
          <div className="mx-auto mb-6 w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
            <Construction className="h-10 w-10 text-primary" />
          </div>
          
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Site en maintenance
          </h1>
          
          <p className="text-muted-foreground mb-8 text-lg leading-relaxed">
            Nous effectuons actuellement des améliorations sur le site du Collectif Ibbü. 
            Nous serons de retour très bientôt.
          </p>
          
          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-xs text-muted-foreground">
              Merci de votre patience et de votre compréhension.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MaintenancePage;
